module.exports = __webpack_public_path__ + "img/back16.e4d2bd5b.png";